import React, { useState } from "react";
import Aside from "../sidenav";
import Header from "../header";

const DefaultLayout = ({ children, setSearchHeaderKey }) => {
  const [showAside, setShowAside] = React.useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="flex">
        <Aside showAside={showAside} setShowAside={setShowAside} />
        <div className={`flex-1 ${showAside ? '!w-[calc(100%-300px)]' : '!w-[calc(100%)]'} min-h-screen`}>
          <Header
            setShowAside={setShowAside}
            showAside={showAside}
            setSearchHeaderKey={setSearchHeaderKey}
          />
          <div className="p-2">
            <div className="max-w-9xl mx-auto w-full">
              {children}
            </div>
          </div>
        </div>
      </div>
      
      {/* Mobile overlay */}
      {showAside && (
        <div 
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setShowAside(false)}
        />
      )}
    </div>
  );
};

export default DefaultLayout;
